<template>
  <div class="flex">
        <div class="content">
          <h1>{{ $route.params.id }}</h1>
        </div>
  </div>      
</template>


<script>

export default {
  name:"damage",
    components:{
    },  
  data () {
    return {
    }
  },
  methods : {}
};
</script>
